import LineItem from './types/LineItem'
import Order from './types/Order'
import Photo, { IMAGE_UPLOAD_STATUS, ImageUploadResponse } from './types/Photo'
import PRODUCT_RETURN_REASON_CODE from './types/productReturnReasonCode'
import REFUND_TYPES from './types/RefundTypes'
import RETURN_MODES from './types/ReturnModes'
import { ProductReturnCard, ProductReturnData } from './types/useReturnController.types'
import useReturnController, { RETURN_STAGE_NO_VS_NAME } from './useReturnController'
import { makeReturnLineItems } from './useReturnController.helpers'

export default useReturnController

export {
  IMAGE_UPLOAD_STATUS,
  PRODUCT_RETURN_REASON_CODE,
  REFUND_TYPES,
  RETURN_MODES,
  RETURN_STAGE_NO_VS_NAME,
  makeReturnLineItems,
  type ImageUploadResponse,
  type LineItem,
  type Order,
  type Photo,
  type ProductReturnCard,
  type ProductReturnData,
}
